import errors from './errors';

export default () => {
  return {
    title: errors.graphQL.default.title,
    message: errors.graphQL.default.message,
  };
};
